import InstagramGalleryEntity from "@apps/instagram/entities/InstagramGalleryEntity";
import InstagramGalleryService from "@apps/instagram/services/InstagramGalleryService";
import InstagramGalleryServiceInterface from "@apps/instagram/services/InstagramGalleryService/InstagramGalleryServiceInterface";
import { Observable } from "rxjs";

class InstagramGalleryServiceInstagramPageAdapter
    implements InstagramGalleryServiceInterface
{
    constructor(
        private readonly instagramGalleryService: InstagramGalleryService
    ) {}

    getGallery(): Observable<InstagramGalleryEntity> {
        return this.instagramGalleryService.getGallery();
    }
}

export default InstagramGalleryServiceInstagramPageAdapter;
